import { SampleFields } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/sample-fields.enum';

export const paternitySampleFieldSet = [
  SampleFields.Participant,
  SampleFields.SampleType,
  SampleFields.EditFieldsAvailable,
];
